import type { DistributiveOmit } from "@/types";
import { mergeSx } from "@/utils";
import type { ReactElement } from "react";

import { Pagination, type PaginationProps } from "@/components/Pagination";

export function TablePagination<
  RC extends ReactElement | undefined = undefined,
>({ sx, className, ...props }: DistributiveOmit<PaginationProps<RC>, "size">) {
  return (
    <Pagination
      {...props}
      className={`${className ?? ""} TablePagination`}
      sx={mergeSx(
        {
          maxw: "470px",
        },
        sx,
      )}
      buttonSx={{
        h: "40px",
      }}
      size="small"
    />
  );
}

TablePagination.displayName = "TablePagination";
